// PRD
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://services.qmob.pt';

export const FILES_BASE_URL = process.env.REACT_APP_FILES_BASE_URL || 'https://storage.googleapis.com/wgs-prd/qmob/';

//export const corsProxy = ''; // 'https://cors.ripka.workers.dev/?';

//export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoid2dzLXN3IiwiYSI6ImNtamQ1ejdtdzAybnYzZXNlMTV6d3ZqOGYifQ.CWyoBzCM-PaTN2BYvURpdw';

export const CMS_API_URL = 'https://content.wegoshare.com/api'

export const CMS_API_KEY = 'b7eba1c1240c0ac0b0121c26ef3caaab9c03ce632b67e16893686a0847327cc82434368fbf6ca140d6621793817b9991e6f4944a7f31fe521ed044c8d5efdfca735990e7befddc9dce4d6f6e6b3c4a096b56cc02915f1b9c4aa574bb49a5eb2b884959b53cbe704d71ec3ec9606a03e869287b635262aed561a587cd820a2f5b'

// QA
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://services.porto.qa.wegoshare.com';

//export const FILES_BASE_URL = process.env.REACT_APP_FILES_BASE_URL || 'https://storage.googleapis.com/wgs-qa/qmob/';

export const corsProxy = ''; // 'https://cors.ripka.workers.dev/?';

export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoid2dzLXN3IiwiYSI6ImNtamQ1ejdtdzAybnYzZXNlMTV6d3ZqOGYifQ.CWyoBzCM-PaTN2BYvURpdw';